import { render, staticRenderFns } from "./SwUpdated.vue?vue&type=template&id=77dba17c"
import script from "./SwUpdated.vue?vue&type=script&lang=js"
export * from "./SwUpdated.vue?vue&type=script&lang=js"
import style0 from "./SwUpdated.vue?vue&type=style&index=0&id=77dba17c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports